import React, { useState } from "react";
import UserDetailsHeader from "../../UserDetailsHeader";
import {
  Box,
  MenuItem,
  Select,
  Tab,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "./romModuleNavTab.scss";
import ROMLeftFlexion from "./ROMLeftFlexion";
import ROMLeftExtension from "./ROMLeftExtension";
import ROMRightFlexion from "./ROMRightFlexion";
import ROMRightExtension from "./ROMRightExtension";

const ROMModuleNavTab = () => {
  const [value, setValue] = useState(0);
  const navTab = [
    "Left Flexion",
    "Left Extension",
    "Right Flexion",
    "Right Extension",
  ];

  // useEffect(() => {
  //   sessionStorage.setItem("romTabIndex", 0);
  // }, []);
  const tabHandler = (newValue) => {
    setValue(newValue);
    // sessionStorage.setItem("romTabIndex", newValue);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <UserDetailsHeader removeReportId={true}>
      <div className="rom-info-test-module-box-wrapper">
        <Typography className="title">Range of Motion - Knee</Typography>
        <Box className="rom-nav-tab-box-wrapper">
          {isMobile ? (
            <Select
              value={value}
              onChange={(e) => tabHandler(e.target.value)}
              className="mobile-view-test-module-dropdown"
            >
              {navTab.map((item, index) => {
                return (
                  <MenuItem value={index} key={index}>
                    {item}
                  </MenuItem>
                );
              })}
            </Select>
          ) : (
            <Box className="rom-nav-tab-menu-box">
              <div className="rom-nav-tab-item-wrap">
                {navTab.map((item, index) => {
                  return (
                    <Tab
                      label={item}
                      key={index}
                      variant="fullWidth"
                      onClick={() => tabHandler(index)}
                      className={`rom-nav-tab-menu-item + ${value === index && `selected`}`}
                    />
                  );
                })}
              </div>
            </Box>
          )}
          {value === 0 && (
            <div value="1" className="rom-info-block">
              <ROMLeftFlexion />
            </div>
          )}
          {value === 1 && (
            <div value="2" className="rom-info-block">
              <ROMLeftExtension />
            </div>
          )}
          {value === 2 && (
            <div value="3" className="rom-info-block">
              <ROMRightFlexion />
            </div>
          )}
          {value === 3 && (
            <div value="4" className="rom-info-block">
              <ROMRightExtension />
            </div>
          )}
        </Box>
      </div>
    </UserDetailsHeader>
  );
};

export default ROMModuleNavTab;
